import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e28eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2 text-xl text-white" }
const _hoisted_2 = { class: "text-md text-gray-text my-5" }
const _hoisted_3 = {
  key: 0,
  class: "form-group md:flex lg:block xl:flex mb-3 items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-sm w-40 my-2 xl:my-0" }, "Wallet Address In Use", -1))
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["copyValue"]
const _hoisted_7 = { class: "md:flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:w-40 lg:w-0 xl:w-40" }, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Connect")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Change Account")
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "inline-block" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://developers.xarcade.io/docs/Onboarding/TestnetWalletSetup/web_wallet_setup",
  target: "_new",
  class: "text-white inline-block text-sm"
}, "Quick start guide", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "my-2 py-2 px-2 rounded-md bg-black-sidebar text-gray-text max-w-max font-bold text-xs" }, [
  /*#__PURE__*/_createTextVNode("*Please Note that this is the Testnet 2 Network. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://developers.xarcade.io/docs/Onboarding/intro",
    target: "_blank",
    class: "hover:underline text-blue-primary"
  }, "Find out More")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-5 border-t border-black-border" }, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "card-body mt-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl text-white" }, "Sirius Faucet", -1))
const _hoisted_20 = { class: "text-md text-gray-text my-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:flex mt-8 md:self-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300 text-sm w-40 my-2 md:my-0" }, "Send XPX to Wallet"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2 tablet:mt-0" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://bctestnet2faucet.xpxsirius.io/#/",
      target: "_blank",
      class: "btn-primary",
      style: {"font-size":"13px"}
    }, "Top Up XPX ")
  ])
], -1))
const _hoisted_22 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_23 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_24 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_25 = {
  class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-md w-full m-2",
  id: "popupQR"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_27 = { class: "modal-content bg-black-body text-white" }
const _hoisted_28 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_29 = { class: "border-0 pb-1 text-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title px-3 text-center",
  id: "staticBackdropLabel"
}, "Scan QR from mobile wallet to connect", -1))
const _hoisted_31 = { class: "w-full text-center my-5" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "flex flex-col text-left space-y-2 p-4 mt-4 mb-2 w-full bg-black-card mx-auto text-gray-text text-xs" }
const _hoisted_34 = { class: "list-outside list-disc space-y-2 px-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Please move the QR Scanner closer to the QR Code ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " If QR code is unreadable, please make sure monitor screen is at full brightness ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://developers.xarcade.io/docs/Onboarding/create_token",
  target: "_new",
  class: "hover:underline text-blue-400"
}, "Find out More", -1))
const _hoisted_38 = { class: "text-center border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", _hoisted_1, "Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet", 1),
    _createElementVNode("p", _hoisted_2, "Connect the Wallet Address of your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Mobile Wallet to receive " + _toDisplayString(_ctx.testnetLabel) + " XPX which has no real-world value and is used to blockchain your game.", 1),
    (_ctx.currentWalletAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentWalletAddress) = $event)),
              class: "form-control text-white border-0",
              disabled: "",
              id: "walletAddress",
              copyValue: _ctx.currentWalletAddress
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.currentWalletAddress]
            ]),
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-copy",
              class: "text-gray-text hover:text-white ml-2 transition-all duration-200 cursor-pointer inline-block",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy('walletAddress')))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: "btn-primary mt-3 mb-4 text-white inline-block mr-2 text-sm w-full sm:w-auto",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.generateQr()), ["prevent"])),
          href: "#",
          style: {"font-size":"13px"}
        }, [
          (!_ctx.currentWalletAddress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-refresh",
                  class: "inline-block mr-2"
                }),
                _hoisted_10
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-exchange",
                  class: "inline-block mr-2"
                }),
                _hoisted_12
              ]))
        ]),
        _createElementVNode("a", {
          class: "mt-3 mb-4 text-black-ori rounded-md bg-yellow-bar px-3 py-2 mr-2 inline-block w-full sm:w-auto",
          href:  _ctx.assetUrl + 'blob/downloads/sirius-mobile-wallet-testnet.apk',
          target: "_blank",
          style: {"font-size":"13px"}
        }, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-brands fa-android",
              class: "inline-block mr-2"
            }),
            _createTextVNode("Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet apk (v" + _toDisplayString(_ctx.testnet2ApkVersion) + ")", 1)
          ])
        ], 8, _hoisted_13),
        _hoisted_15,
        _hoisted_16
      ])
    ]),
    _hoisted_17,
    (_ctx.currentWalletAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("p", _hoisted_20, " You will need " + _toDisplayString(_ctx.testnetLabel) + " XPX in your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet to blockchain your " + _toDisplayString(_ctx.testnetLabel) + " game. After connecting your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet with the Wallet Address appears above, copy the address, click on the below button to Sirius " + _toDisplayString(_ctx.testnetLabel) + " faucet and paste the same address to receive a maximum of 100,000 " + _toDisplayString(_ctx.testnetLabel) + " XPX in your Sirius " + _toDisplayString(_ctx.testnetLabel) + " Wallet. You can top up with a maximum of 100,000 " + _toDisplayString(_ctx.testnetLabel) + " XPX every 24 hours. ", 1),
          _hoisted_21
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayConnectTestnet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayConnectTestnet)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayConnectTestnet = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", {
                              class: "inline-block",
                              innerHTML: _ctx.qr
                            }, null, 8, _hoisted_32)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("ul", _hoisted_34, [
                              _hoisted_35,
                              _hoisted_36,
                              _createElementVNode("li", null, [
                                _createTextVNode(" Please make sure " + _toDisplayString(_ctx.testnetLabel + " 2") + " node (" + _toDisplayString(_ctx.testneturl) + ") is selected on Sirius wallet. ", 1),
                                _hoisted_37
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-white text-center rounded-md duration-150 transition-all disabled:opacity-60 bg-gray-600 hover:bg-blue-primary px-10 py-2 text-sm",
                            "data-bs-dismiss": "modal",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.isQRModalShow = false; _ctx.createToken})
                          }, "Confirm")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}